"use client";

/**
 * Ağır kütüphaneleri İLK KULLANIMDA yükler.
 *
 * Sorun: araç bileşenleri pdf-lib, jszip ve docx'i dosyanın tepesinden statik
 * olarak içe aktarıyordu. Bu, kullanıcı daha dosya bile seçmeden sayfaya girer
 * girmez yüzlerce kilobaytlık JS indirilip ayrıştırılması demekti —
 * /cv-olustur/ sayfasında 861 KB, PDF araçlarında ~425 KB.
 *
 * Çözüm: kütüphane yalnızca işlem başladığında indirilir. Ayrıca bellekte
 * tutmaya gerek yok: dinamik import()'u modül sistemi zaten önbelleğe alır,
 * aynı sayfada ikinci çağrı ağdan tekrar indirmez.
 *
 * Desen src/lib/pdf.ts içindeki getPdfjs ile aynı amacı taşır.
 */

/** pdf-lib — PDF oluşturma/düzenleme. */
export const getPdfLib = () => import("pdf-lib");

/** docx — Word (.docx) çıktısı üretimi. */
export const getDocx = () => import("docx");

/** JSZip — çoklu çıktıyı tek arşivde indirmek için. */
export async function getJSZip() {
  return (await import("jszip")).default;
}

/** fontkit — PDF'e Türkçe destekli yazı tipi gömmek için. */
export async function getFontkit() {
  return (await import("@pdf-lib/fontkit")).default;
}
